<div id="loginW">
  <dx-validation-group>
    <div class="login-header">
      <!-- <div class="title">{{appInfo.title}}</div> -->
      <img src="../../../../assets/ihunter-logo.png" alt="ihunter" class="img-responsive login-logo">
      <!-- <div>Ingresar a la plataforma</div> -->
    </div>
    <!-- LOGI FORM  -->
    <div class="loginW" *ngIf="!requestingEmail">
      <div class="dx-field bad-login" *ngIf="errorMsg">
        Error, favor de tratar nuevamente
      </div>
      <div class="dx-field bad-login" *ngIf="errorMsg2">
        <div class="fullWith"> Error, Su usuario NO tiene permisos para acceder a esta plataforma.
          Trate de accesar a nuestra</div>
        <div class="fullWith mt-2">
          <a href="https://mobile.ihunter.io/">Aplicación Móvil</a>
        </div>
      </div>
      <div class="dx-field">
        <dx-text-box [(value)]="email" placeholder="Email" width="100%">
          <dx-validator>
            <dxi-validation-rule type="required" message="Email es neccesario"></dxi-validation-rule>
          </dx-validator>
        </dx-text-box>
      </div>
      <div class="dx-field">
        <dx-text-box width="100%" placeholder="password" stylingMode="filled" [(value)]="password"
          [(mode)]="passwordMode" id="pswdW">
          <dx-validator>
            <dxi-validation-rule type="required" message="Password es requerido"></dxi-validation-rule>
          </dx-validator>
          <dxi-button name="eye" [options]="passwordButton" cssClass="ojito"></dxi-button>
        </dx-text-box>
      </div>
      <div class="dx-field">
        <dx-button type="default" text="ENTRAR" (onClick)="signIn($event)" width="100%" (keyup.enter)="signIn($event)">
        </dx-button>
      </div>
      <div class="txt-center">
        <a class="aling-center myPointer" (click)="forgotPswd(true)">Olvide contraseña</a>
        <p class="mt-4">info@ihunter.io</p>
      </div>
    </div>
    <!-- REQUEST EMAIL TO RESET PASSWORD -->
    <div class="loginW" *ngIf="requestingEmail">
      <div class="dx-field bad-login" *ngIf="emailSenntMessage">
        Si su correo se encuentra en el sistema, recibirás las instrucciones en unos minutos
      </div>
      <div class="instTxt">Ingresa tu email y te enviaremos instrucciones por correo para restablecer tu
        contraseña.
      </div>
      <div class="dx-field">
        <dx-text-box [(value)]="email2" placeholder="Email" width="100%">
          <dx-validator>
            <dxi-validation-rule type="required" message="Email es neccesario"></dxi-validation-rule>
          </dx-validator>
        </dx-text-box>
      </div>

      <div class="dx-field">
        <dx-button type="default" text="Reestablecer" (onClick)="requestEmail()" width="100%" stylingMode="outlined">
        </dx-button>
      </div>
      <div class="dx-field txt-center">
        <a class="aling-center myPointer" (click)="forgotPswd(false)">Ingresar</a>
      </div>
    </div>
  </dx-validation-group>
</div>